import { render } from "./paygrade-details.vue?vue&type=template&id=bf087556&scoped=true"
import script from "./paygrade-details.vue?vue&type=script&lang=js"
export * from "./paygrade-details.vue?vue&type=script&lang=js"

import "./paygrade-details.vue?vue&type=style&index=0&id=bf087556&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf087556"]])

export default __exports__